import { statusField } from "../../../../helper/validField";
import { BcFieldProps } from "../../../interface/props/bcfield";
import { BCInputCont, BCTextArea } from "../../../styled/global.styled";

const TextAreaField = ({ field, register, isRequired, errors, touchedFields, dirtyFields }: BcFieldProps) => (
    <BCInputCont className="bc-form-field">
        <BCTextArea
            className={`bc-input-area ${statusField(errors[field.item], touchedFields[field.item], !dirtyFields[field.item], !errors[field.item])}`}
            placeholder={field.placeholder}
            aria-label={field.label}
            id={field.item}
            {...register(field.item, { required: isRequired })}
        ></BCTextArea>
        <label htmlFor={field.item}>{field.label}</label>
        <span>{errors[field.item] ? 'Este campo es Obligatorio *' :  'Campo Obligatorio *'} </span>
    </BCInputCont>
);
 
export default TextAreaField 